import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
`

export const Row = styled(Container)`
  flex-direction: row;
  padding: 0px;
  gap: 10px;
`

export const TabRow = styled(Container)`
  flex-direction: row;
  margin-bottom: 10px;
  padding: 0px;
  gap: 10px;
`

export const ListContainer = styled(Container)`
  padding: 10px 0px 30px;
`

export const FilterContainer = styled(Container)`
  flex-direction: row;
  width: 640px;
  height: auto;
  gap: 10px;
  padding-top: 5px;
  margin-bottom: 10px;

  button {
    margin: 0px;
  }
`
